class Config {
    constructor () {
        this.domain = window.location.protocol + '//' + window.location.hostname;
    }

    getDomain () {
        return this.domain;
    }
}

export default Config;
